import { combineReducers } from "redux";
import accountingTasksSlice from "../../features/AccountingTasks/services/store/accountingTasks.reducer";
import { adminArea } from "../../admin/services/store/adminarea.reducer";
import { alert } from "./alert.reducer";
import { amazonPay } from "../../integrations/Amazon/Pay/services/store/amazonpay.reducer";
import userAuthenticationSlice from "../../user/services/store/authentication.reducer";
import braintreeSlice from "../../integrations/payment/Braintree/store/braintree.reducer";
import { converter } from "../../features/Converter/services/store/converter.reducer";
import { downloader } from "../../features/FileDownloads/services/store/downloader.reducer";
import { integration } from "../../integrations/_services/store/integrations.reducer";
import { lexoffice } from "../../integrations/LexOffice/services/store/lexoffice.reducer";
import mollieSlice from "../../integrations/payment/Mollie/store/mollie.reducer";
import { navigation } from "./navigation.reducer";
import { setup } from "../../user/services/store/setup.reducer";
import platformUserSlice from "../../user/services/store/user.reducer";
import { oss } from "../../features/OSSDashboard/services/store/oss.reducer";
import { paymentsMatching } from "../../features/PaymentsMatching/services/store/paymentsMatching.reducer";
import amazonOrderSlice from "../../integrations/shop/AmazonOrder/services/store/amazonOrderAdmin.reducer";
import shopifyOrderSlice from "../../integrations/shop/Shopify/Order/services/store/shopifyOrder.reducer";
import shopwareSlice from "../../integrations/Shopware/services/store/shopwareAdmin.reducer";
import wooCommerceSlice from "../../integrations/shop/WooCommerce/store/wooCommerce.reducer";
import taskManagerSlice from "../../features/TaskManager/services/store/taskmanager.reducer";
import snipcartSlice from "../../integrations/SnipCart/services/store/snipcart.reducer";
import storeganiseSlice from "../../integrations/Storeganise/services/store/storeganise.reducer";
import clientSlice from "../../organization/client/services/clients.reducer";
import amazonPayoutSlice from "../../integrations/Amazon/Payout/services/store/amazonPayout.reducer";
import commonsSlice from "../../commons/services/store/commons.reducer";
import appstoreSetupSlice from "../../user/services/store/appstoreSetup.reducer";
import countToolSlice from "../../admin/modules/count/services/Store/count.reducer";
import searchToolSlice from "../../admin/modules/search/services/Store/search.reducer";
import myOrganizationSlice from "../../organization/myOrganization/services/store/myOrganization.reducer";
import userManagementSlice from "../../organization/userManagement/services/store/userManagement.reducer";
import exchangeRateSlice from "../../admin/modules/exchangeRate/services/store/exchangeRate.reducer";
import pathwayBillingConfigurationSlice
    from "../../integrations/PaythwayBilling/services/store/billing-configuration.reducer";
import pathwayBillingDataSlice from "../../integrations/PaythwayBilling/services/store/billing-data.reducer";
import pathwayBillingDownloadSlice from "../../integrations/PaythwayBilling/services/store/billing-download.reducer";
import pathwayBillingBulkActionSlice from "../../integrations/PaythwayBilling/services/store/billing-bulkaction.reducer";
import notificationSlice from "../../notification/store/notification.reducer";
import vipSupportSlice from "../../vipSupport/store/vipSupport.reducer";
import marketplaceSetupSlice from "../../user/services/store/marketplaceSetup.reducer";
import mandateOnboardingSlice from "../../organization/neuesMandat/services/store/mandateOnboarding.reducer";
import userRegistrationSlice from "../../user/services/store/userRegistration.reducer";
import paypalSlice from "../../integrations/payment/PayPal/store/paypal.reducer";
import tiktokPaymentsSlice from "../../integrations/payment/TikTokPayments/store/tiktokPayments.reducer";
import tiktokShopSlice from "../../integrations/shop/TikTokShop/store/tikTokShop.reducer";
import aboutYouSlice from "../../integrations/shop/AboutYou/store/aboutYou.reducer";
import aboutYouPaymentsSlice from "../../integrations/shop/AboutYou/payments/store/aboutYouPayments.reducer";
import klarnaSlice from "../../integrations/payment/Klarna/store/klarna.reducer";
import gocardlessSlice from "../../integrations/payment/GoCardless/store/gocardless.reducer";
import amazonPaySlice from "../../integrations/payment/AmazonPay/store/amazonPay.reducer";
import shopifyPaymentsSlice from "../../integrations/payment/ShopifyPayments/services/store/shopifyPayments.reducer";
import StripePaymentsSlice from "../../integrations/payment/StripePayments/store/stripePayments.reducer";
import organizationBillingSlice from "../../organization/billing/store/organizationBilling.reducer";
import shopifyPosSlice from "../../integrations/payment/ShopifyPos/store/shopifyPos.reducer";
import adyenSlice from "../../integrations/payment/Adyen/store/adyen.reducer";
import chargebeeSlice from "../../integrations/billing/Chargebee/services/store/chargebee.reducer";
import stripeBillingSlice from "../../integrations/billing/StripeBilling/services/store/stripeBilling.reducer";
import unzerSlice from "../../integrations/payment/Unzer/store/unzer.reducer";
import ebaySlice from "../../integrations/shop/eBay/store/ebay.reducer";
import ebayPaymentsSlice from "../../integrations/shop/eBay/payments/store/ebayPayments.reducer";
import ottoSlice from "../../integrations/shop/Otto/store/otto.reducer";
import ottoPaymentsSlice from "../../integrations/shop/Otto/payments/store/ottoPayments.reducer";
import kauflandSlice from "../../integrations/shop/Kaufland/store/kaufland.reducer";
import kauflandPaymentsSlice from "../../integrations/shop/Kaufland/payments/store/kauflandPayments.reducer";
import chargingSlice from "../../admin/modules/charging/services/store/charging.reducer";
import zalandoSlice from "../../integrations/shop/Zalando/store/zalando.reducer";
import zalandoPaymentsSlice from "../../integrations/shop/Zalando/payments/store/zalandoPayments.reducer";
import standardmandatSlice from "../../organization/standardmandat/services/store/standardmandat.reducer";

const integrations = combineReducers({
    aboutYou: aboutYouSlice.reducer,
    aboutYouPayments: aboutYouPaymentsSlice.reducer,
    adyen: adyenSlice.reducer,
    amazonPay,
    amazonPayV2: amazonPaySlice.reducer,
    amazonPayout: amazonPayoutSlice.reducer,
    amazonOrder: amazonOrderSlice.reducer,
    integration,
    braintree: braintreeSlice.reducer,
    chargebee: chargebeeSlice.reducer,
    ebay: ebaySlice.reducer,
    ebayPayments: ebayPaymentsSlice.reducer,
    otto: ottoSlice.reducer,
    ottoPayments: ottoPaymentsSlice.reducer,
    kaufland: kauflandSlice.reducer,
    kauflandPayments: kauflandPaymentsSlice.reducer,
    gocardless: gocardlessSlice.reducer,
    klarna: klarnaSlice.reducer,
    mollie: mollieSlice.reducer,
    lexoffice,
    paypal: paypalSlice.reducer,
    shopifyOrder: shopifyOrderSlice.reducer,
    shopifyPayments: shopifyPaymentsSlice.reducer,
    shopifyPos: shopifyPosSlice.reducer,
    stripePayments: StripePaymentsSlice.reducer,
    shopware: shopwareSlice.reducer,
    snipcart: snipcartSlice.reducer,
    storeganise: storeganiseSlice.reducer,
    stripeBilling: stripeBillingSlice.reducer,
    tiktokPayments: tiktokPaymentsSlice.reducer,
    tiktokShop: tiktokShopSlice.reducer,
    unzer: unzerSlice.reducer,
    wooCommerce: wooCommerceSlice.reducer,
    zalando: zalandoSlice.reducer,
    zalandoPayments: zalandoPaymentsSlice.reducer,
});

// TODO: When usual AdminArea reducer is refactored then merge it with adminTools
const adminTools = combineReducers({
    charging: chargingSlice.reducer,
    countTool: countToolSlice.reducer,
    searchTool: searchToolSlice.reducer,
    exchangeRates: exchangeRateSlice.reducer,
});

const pathwayBilling = combineReducers({
    configuration: pathwayBillingConfigurationSlice.reducer,
    data: pathwayBillingDataSlice.reducer,
    downloads: pathwayBillingDownloadSlice.reducer,
    bulkActions: pathwayBillingBulkActionSlice.reducer,
});

const rootReducer = combineReducers({
    authentication: userAuthenticationSlice.reducer,
    accountingTasks: accountingTasksSlice.reducer,
    adminArea,
    adminTools,
    alert,
    commons: commonsSlice.reducer,
    notification: notificationSlice.reducer,
    client: clientSlice.reducer,
    converter,
    downloader,
    integrations,
    navigation,
    myOrganization: myOrganizationSlice.reducer,
    userManagement: userManagementSlice.reducer,
    organizationBilling: organizationBillingSlice.reducer,
    oss,
    pathwayBilling,
    paymentsMatching,
    userRegistration: userRegistrationSlice.reducer,
    setup,
    taskManager: taskManagerSlice.reducer,
    user: platformUserSlice.reducer,
    appstoreSetup: appstoreSetupSlice.reducer,
    marketplaceSetup: marketplaceSetupSlice.reducer,
    vipSupport: vipSupportSlice.reducer,
    mandateOnboarding: mandateOnboardingSlice.reducer,
    standardmandat: standardmandatSlice.reducer,
});

export default rootReducer;

export const accountingTaskReducerActions = accountingTasksSlice.actions;
export const adyenReducerActions = adyenSlice.actions;
export const amazonPayoutReducerActions = amazonPayoutSlice.actions;
export const amazonOrderReducerActions = amazonOrderSlice.actions;
export const chargebeeReducerActions = chargebeeSlice.actions;
export const ebayReducerActions = ebaySlice.actions;
export const ebayPaymentsReducerActions = ebayPaymentsSlice.actions;
export const ottoReducerActions = ottoSlice.actions;
export const ottoPaymentsReducerActions = ottoPaymentsSlice.actions;
export const kauflandReducerActions = kauflandSlice.actions;
export const kauflandPaymentsReducerActions = kauflandPaymentsSlice.actions;
export const zalandoReducerActions = zalandoSlice.actions;
export const zalandoPaymentsReducerActions = zalandoPaymentsSlice.actions;
export const gocardlessReducerActions = gocardlessSlice.actions;
export const braintreeReducerActions = braintreeSlice.actions;
export const klarnaReducerActions = klarnaSlice.actions;
export const mollieReducerActions = mollieSlice.actions;
export const paypalReducerActions = paypalSlice.actions;
export const amazonPayReducerActions = amazonPaySlice.actions;
export const stripeBillingReducerActions = stripeBillingSlice.actions;
export const shopifyOrderReducerActions = shopifyOrderSlice.actions;
export const shopifyPaymentsReducerActions = shopifyPaymentsSlice.actions;
export const shopifyPosReducerActions = shopifyPosSlice.actions;

export const stripePaymentsReducerActions = StripePaymentsSlice.actions;
export const shopwareReducerActions = shopwareSlice.actions;
export const wooCommerceReducerActions = wooCommerceSlice.actions;
export const snipcartReducerActions = snipcartSlice.actions;
export const storeganiseReducerActions = storeganiseSlice.actions;
export const unzerReducerActions = unzerSlice.actions;
export const tiktokPaymentsReducerActions = tiktokPaymentsSlice.actions;
export const tiktokShopReducerActions = tiktokShopSlice.actions;
export const aboutYouReducerActions = aboutYouSlice.actions;
export const aboutYouPaymentsReducerActions = aboutYouPaymentsSlice.actions;

export const taskManagerReducerActions = taskManagerSlice.actions;
export const platformUserReducerActions = platformUserSlice.actions;
export const userRegistrationReducerActions = userRegistrationSlice.actions;
export const clientReducerActions = clientSlice.actions;
export const commonsReducerActions = commonsSlice.actions;
export const notificationReducerActions = notificationSlice.actions;
export const vipSupportReducerActions = vipSupportSlice.actions;
export const authenticationReducerActions = userAuthenticationSlice.actions;
export const appstoreSetupReducerActions = appstoreSetupSlice.actions;
export const marketplaceSetupReducerActions = marketplaceSetupSlice.actions;
export const mandateOnboardingReducerActions = mandateOnboardingSlice.actions;
export const standardmandatReducerActions = standardmandatSlice.actions;

// Admin Tools
export const countToolReducerActions = countToolSlice.actions;
export const searchToolReducerActions = searchToolSlice.actions;
export const myOrganizationReducerActions = myOrganizationSlice.actions;
export const userManagementReducerActions = userManagementSlice.actions;
export const organizationBillingReducerActions = organizationBillingSlice.actions;
export const exchangeRateReducerActions = exchangeRateSlice.actions;

export const billingConfigurationReducerActions = pathwayBillingConfigurationSlice.actions;
export const billingDataReducerActions = pathwayBillingDataSlice.actions;
export const billingDownloadReducerActions = pathwayBillingDownloadSlice.actions;
export const billingBulkActionReducerActions = pathwayBillingBulkActionSlice.actions;
export const chargingReducerActions = chargingSlice.actions;
